import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/icons/up-right-3.svg'


const _withScopeId = n => (_pushScopeId("data-v-1d4eeeed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "promo-wrap ptb-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-xl-10 offset-xl-1" }, [
      /*#__PURE__*/_createElementVNode("h2", { class: "section-title style-four pb-100 white" }, " Strategic Market Focus: Launch Strategy ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "promo-bg bg-f" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "content-wrap" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "content-title style-one" }, [
        /*#__PURE__*/_createElementVNode("h6", { class: "section-subtitle" }, [
          /*#__PURE__*/_createTextVNode(" Flagship Unit "),
          /*#__PURE__*/_createElementVNode("span", null, "Launch")
        ]),
        /*#__PURE__*/_createElementVNode("h2", { style: {"color":"#b5ff00"} }, "Nassau County, Long Island"),
        /*#__PURE__*/_createElementVNode("p", null, " Nassau County is strategically selected as the launch market due to its ideal demographic profile: 1.39 million residents, median household income of $143,000, and a significant Muslim population (48,000+) alongside a substantial Hispanic community (256,000+). "),
        /*#__PURE__*/_createElementVNode("ul", { class: "strategy-list list-style" }, [
          /*#__PURE__*/_createElementVNode("li", null, "Strong demand for combined with Mexican cuisine appreciation"),
          /*#__PURE__*/_createElementVNode("li", null, "Affluent consumer base with cultural diversity"),
          /*#__PURE__*/_createElementVNode("li", null, "Ideal testing ground before broader expansion")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "circle-wrap" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: "Image"
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "circle-text" }, [
        /*#__PURE__*/_createElementVNode("svg", {
          class: "rotate",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          x: "0px",
          y: "0px",
          width: "100%",
          height: "100%",
          viewBox: "0 0 300 300",
          "enable-background": "new 0 0 300 300",
          "xml:space": "preserve"
        }, [
          /*#__PURE__*/_createElementVNode("defs", null, [
            /*#__PURE__*/_createElementVNode("path", {
              id: "circlePath_one",
              d: " M 150, 150 m -60, 0 a 60,60 0 0,1 120,0 a 60,60 0 0,1 -120,0 "
            })
          ]),
          /*#__PURE__*/_createElementVNode("circle", {
            cx: "150",
            cy: "150",
            r: "75",
            fill: "none"
          }),
          /*#__PURE__*/_createElementVNode("g", null, [
            /*#__PURE__*/_createElementVNode("use", {
              "xlink:href": "#circlePath_one",
              fill: "none"
            }),
            /*#__PURE__*/_createElementVNode("text", { fill: "#6b7280" }, [
              /*#__PURE__*/_createElementVNode("textPath", { "xlink:href": "#circlePath_one" }, " Start Your Journey . Start Your Journey . Start Your Journey ")
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}